/* twinelab theme scripts */

/* ---- review modal (from mockup) ---- */
function openReview(card){
  var m = document.getElementById('reviewModal');
  if(!m) return;
  var q = card && card.getAttribute('data-review');
  var n = card && card.getAttribute('data-reviewer');
  if(q){ var el=document.getElementById('rvQuote'); if(el) el.textContent = q; }
  if(n){ var el2=document.getElementById('rvName'); if(el2) el2.textContent = n; }
  m.classList.add('open');
}
function closeReview(){
  var m = document.getElementById('reviewModal');
  if(m) m.classList.remove('open');
}
document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeReview(); });

/* ---- product gallery thumb swap ---- */
document.addEventListener('click',function(e){
  var t = e.target;
  if(t && t.matches('.product-gallery .thumbs img')){
    var main = document.querySelector('.product-gallery .main img');
    if(main){ main.src = t.getAttribute('data-full') || t.src; }
  }
});

/* ---- product variant selection ---- */
(function(){
  var form = document.querySelector('[data-product-form]');
  if(!form) return;
  var variants = window.__twVariants || [];
  var priceEl = document.querySelector('[data-price]');
  var idInput = form.querySelector('input[name="id"]');
  var addBtn  = form.querySelector('.btn-add');

  // How many option groups does this product have?
  var groups = form.querySelectorAll('.opt-group');
  var optionCount = groups.length;

  function currentSelections(){
    // Dense array, one entry per option group, in order.
    var sels = [];
    for(var i = 1; i <= optionCount; i++){
      var checked = form.querySelector('input[name="option' + i + '"]:checked');
      sels.push(checked ? checked.value : null);
    }
    return sels;
  }

  function findVariant(sels){
    for(var i = 0; i < variants.length; i++){
      var v = variants[i];
      var ok = true;
      for(var j = 0; j < sels.length; j++){
        if(sels[j] === null) continue;
        if(String(v.options[j]) !== String(sels[j])){ ok = false; break; }
      }
      if(ok) return v;
    }
    return null;
  }

  function update(){
    var sels = currentSelections();
    var match = findVariant(sels);
    if(!match) return;

    if(idInput) idInput.value = match.id;
    if(priceEl && match.price_formatted) priceEl.innerHTML = match.price_formatted;
    if(addBtn){
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
    }
  }

  form.addEventListener('change', update);
  update();
})();
